var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInstagramBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5298 1.72656H7.61012C4.42593 1.72656 1.84375 4.14215 1.84375 7.12091V13.5941C1.84375 16.5728 4.42593 18.9885 7.61012 18.9885H14.5298C17.7139 18.9885 20.2961 16.5728 20.2961 13.5941V7.12091C20.2961 4.14215 17.7139 1.72656 14.5298 1.72656ZM18.5662 13.5941C18.5662 15.6763 16.7556 17.3702 14.5298 17.3702H7.61012C5.3843 17.3702 3.57366 15.6763 3.57366 13.5941V7.12091C3.57366 5.03869 5.3843 3.34487 7.61012 3.34487H14.5298C16.7556 3.34487 18.5662 5.03869 18.5662 7.12091V13.5941Z",
    fill: "#0d99ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0701 6.04297C8.52254 6.04297 6.45703 7.97522 6.45703 10.3584C6.45703 12.7417 8.52254 14.6739 11.0701 14.6739C13.6178 14.6739 15.6832 12.7417 15.6832 10.3584C15.6832 7.97522 13.6178 6.04297 11.0701 6.04297ZM11.0701 13.0556C9.48092 13.0556 8.18694 11.8451 8.18694 10.3584C8.18694 8.87073 9.48092 7.66127 11.0701 7.66127C12.6593 7.66127 13.9533 8.87073 13.9533 10.3584C13.9533 11.8451 12.6593 13.0556 11.0701 13.0556Z",
    fill: "#0d99ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0287 6.29265C16.3682 6.29265 16.6435 6.0352 16.6435 5.71762C16.6435 5.40003 16.3682 5.14258 16.0287 5.14258C15.6893 5.14258 15.4141 5.40003 15.4141 5.71762C15.4141 6.0352 15.6893 6.29265 16.0287 6.29265Z",
    fill: "#0d99ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagramBlue);
export default __webpack_public_path__ + "static/media/icon-instagram-blue.0b0312d6.svg";
export { ForwardRef as ReactComponent };